module.exports = __webpack_public_path__ + "img/fridge.73c9bf60.png";